module.exports = __webpack_public_path__ + "static/media/unbookmark1.57e1bec3.svg";